import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { AlertProvider } from "./context/AlertContext";
import theme from "./theme/Theme";

export const AppProviders = ({ children, msalInstance }) => (
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <AlertProvider>{children}</AlertProvider>
        </ThemeProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
